import React from 'react';
import { Modal } from 'antd';
import { DetailedSparkJobDTO } from 'types/types';
import { JobPropertiesContent } from './Contents/JobPropertiesContent';
import './JobPropertiesModal.scss';

const JobPropertiesModal: React.FC<{
  job: DetailedSparkJobDTO | undefined;
  onClose: () => void;
  isLoading: boolean;
  clusterName: string;
  isOpen: boolean;
}> = ({ job, onClose, isLoading, isOpen }) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={'calc(90vw - 650px)'}
      className="job-props-modal"
      style={{
        position: 'fixed',
        left: 90,
        top: '50px',
        margin: 0,
        padding: 0,
      }}
      title={
        <div className="job-props__header">
          <p className="job-props__eyebrow">Job Properties</p>
          <p className="job-props__job-id">{job?.sparkJobId ?? '—'}</p>
        </div>
      }
      styles={{ mask: { backdropFilter: 'blur(2px)' } }}>
      <JobPropertiesContent job={job} isLoading={isLoading} />
    </Modal>
  );
};

export default JobPropertiesModal;
